import { render, staticRenderFns } from "./WholeSearchBar.vue?vue&type=template&id=b4055ae0&scoped=true"
import script from "./WholeSearchBar.vue?vue&type=script&lang=ts"
export * from "./WholeSearchBar.vue?vue&type=script&lang=ts"
import style0 from "./WholeSearchBar.vue?vue&type=style&index=0&id=b4055ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4055ae0",
  null
  
)

export default component.exports